import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPinned, subscribePinned } from "@/lib/pins";
import { GitCompareArrows, X } from "lucide-react";

export default function CompareBar() {
    const [pins, setPins] = useState(getPinned());
    useEffect(() => subscribePinned(setPins), []);

    if (pins.length === 0) return null;

    return (
        <div
            data-testid="compare-bar"
            className="fixed bottom-6 left-1/2 z-40 -translate-x-1/2 border border-[#FF2E2E] bg-[#0A0A0A]/95 px-4 py-3 shadow-[0_0_0_1px_rgba(255,46,46,0.3)] backdrop-blur-sm"
        >
            <div className="flex items-center gap-4">
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-400">
                    Épinglés
                </span>
                <span className="font-display text-2xl leading-none text-white">
                    {pins.length}
                    <span className="text-[#FF2E2E]">/3</span>
                </span>
                <Link
                    to="/compare"
                    data-testid="compare-bar-cta"
                    className={`inline-flex items-center gap-2 px-3 py-2 font-mono text-[11px] uppercase tracking-widest transition-colors ${
                        pins.length >= 2
                            ? "bg-[#FF2E2E] text-white hover:bg-[#D61F1F]"
                            : "border border-white/20 text-neutral-500 cursor-not-allowed pointer-events-none"
                    }`}
                >
                    <GitCompareArrows className="h-3.5 w-3.5" />
                    Comparer
                </Link>
                <button
                    data-testid="compare-bar-clear"
                    onClick={() => {
                        localStorage.setItem("earnit_pinned_coaches", "[]");
                        window.dispatchEvent(new CustomEvent("earnit:pins-changed"));
                    }}
                    className="text-neutral-500 hover:text-white"
                    aria-label="Tout retirer"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
